import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { IssSrcComponent } from '../../common/iss-src/iss-src.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';
import { ContractTypeLovDialogComponent } from '../../common/contract-type-lov/contract-type-lov.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
@Component({
  selector: 'agency-standard-rates-per-vehicle-maintenance',
  templateUrl: './agency-standard-rates-per-vehicle-maintenance.component.html',
  styleUrls: ['./agency-standard-rates-per-vehicle-maintenance.component.css']
})
export class AgencyStandardRatesPerVehicleMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM071';
  perilDisabled: boolean = true;
  carCompGrpList: any = [];
  moduleName: string = '';

  selectedIss: any = {
    ISS_CD: '',
    ISS_NAME: '',
    ISS_FIELD: ''
  };

  selectedPeril: any = {
    PERIL_CD:'',
    PERIL_LNAME:'',
    PERIL_FIELD:''
  };

  selectedContract: any = {
    CONTRACT_TYPE_CD:'',
    CONTRACT_TYPE_DESC:'',
    CONTRACT_TYPE_FIELD:''
  };
  tempAddedData: any = [];
  tempUpdateData: any = [];

  paramForm = this.formBuilder.group({
    lineCd: 'MC',
    issueCd: [null],
    issueName: [null],
    issueField: [null],
    contractTypeCd:[null],
    contractTypeName:[null],
    contractTypeField:[null],
    perilCd:[null],
    perilName:[null],
    perilField:[null],
    carCompGrpCd: [null]
  });
  agencyStdRatesPerVehicleForm = this.formBuilder.group({
    premiumRate: [null, [Validators.required, Validators.maxLength(13)]],
    activeTag: ['A', [Validators.required]],
    commissionRate: [null, [Validators.required, Validators.maxLength(13)]],
    servicefeeRate: [null, [Validators.required, Validators.maxLength(13)]],
    defaultTag: ['No', [Validators.required]],
    effDateFrom: [new Date(), [Validators.required]],
    effDateTo: [null],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {  
    this.carCompGrpList = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="CAR_COMP_GRP");
    this.moduleName = this.jsonDataService.data.moduleList.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  agencyStdRatesPerVehicleTblConfig: any = {
    cols: [
      {
        key: "PREM_RT",
        header: "Premium Rate",
        dataType: "rateDecimal"
      },
      {
        key: "COMM_RT",
        header: "Comission Rate",
        dataType: "rateDecimal"
      },
      {
        key: "SERVICE_FEE_RT",
        header: "Service Fee Rate",
        dataType: "rateDecimal"
      },
      {
        key: "EFF_DATE_FROM",
        header: "Effective Date",
        dataType: "date"
      },
      {
        key: "EFF_DATE_TO",
        header: "Expiry Date",
        dataType: "date"
      },
      {
        key: "DEFAULT_TAG",
        header: "Default",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
  }

  initOnGet(): void {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllAgencyStdRatesPerVehicle();
          });
      this.getAllAgencyStdRatesPerVehicle();
    }
    catch(e) {
    }
  }

  async getAllAgencyStdRatesPerVehicle(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      let issueCd = this.paramForm.get('issueCd')?.value;
      let perilCd = this.paramForm.get('perilCd')?.value;
      let contractTypeCd = this.paramForm.get('contractTypeCd')?.value;
      let carCompGrpCd = this.paramForm.get('carCompGrpCd')?.value;

      console.log("Fetching Agency Standard Rates with parameters:");
      console.log("lineCd:", lineCd, "issueCd:", issueCd, "perilCd:", perilCd, "contractTypeCd:", contractTypeCd);

      if (lineCd && issueCd&& perilCd&& contractTypeCd && carCompGrpCd) {
        const params = {
          queryParams:{
            issueCd: issueCd,
            lineCd: lineCd,
            perilCd: perilCd,
            contractTypeCd: contractTypeCd,
            carCompGrpCd: carCompGrpCd
          },
          moduleId: this.moduleId,
          userId: this.userDetailService.userId,
          type: "MODULE"
        }

        console.log("API Call Parameters:", params);

        this.agencyStdRatesPerVehicleTblConfig.loading = true;
        this.apiCallService.getAgencyStandardRatesPerVehicle(params).subscribe({
          next: (data: any) => {
            console.log("Raw API Response:", data);
            console.log("API Call Parameters:", params);

            this.securityService.checkRequestKeyResponse(data, ()=>{
              this.securityService.hasValidCsrfToken(data, ()=>{
                data = JSON.parse(this.jsonDataService.decrypt(data.response));
                let rawData:any = [];
                let finalData:any = [];
                if(!Array.isArray(data)){
                  rawData.push(data);
                }
                else{
                  rawData = data;
                }
                // finalData = this.populateTempData(finalData, rawData);
                console.log("Processed Raw Data:", rawData);
                if(rawData.length>1){
                  rawData.sort(function(a:any, b:any){
                    let aPremRt = Number(a.PREM_RT);
                    let bPremRt = Number(b.PREM_RT);
                    return aPremRt - bPremRt;
                  });
            
                  for(let item of rawData){
                    if(item.DEFAULT_TAG.toUpperCase()=='Y'){
                      item.DEFAULT_TAG = 'Yes';
                    }else{
                      item.DEFAULT_TAG= 'No';
                    }
                  }
                }
                else if(rawData.length==1){
                  for(let item of rawData){
                    if(item.DEFAULT_TAG.toUpperCase()=='Y'){
                      item.DEFAULT_TAG = 'Yes';
                    }else{
                      item.DEFAULT_TAG= 'No';
                    }
                  }
                }

                console.log("Final Table Data:", rawData);

                this.agencyStdRatesPerVehicleTblConfig.tblData = rawData;
                this.agencyStdRatesPerVehicleTblConfig.loading = false;
                this.tempAddedData = [];
                this.tempUpdateData = [];
                this.saveDisabled = this.saveChecker();
              });
            })
          },
          error: (e: any) => {
            this.agencyStdRatesPerVehicleTblConfig.loading = false;
          }
        });
      }else{
        this.agencyStdRatesPerVehicleTblConfig.loading = true;
        this.agencyStdRatesPerVehicleTblConfig.tblData = [];
        this.agencyStdRatesPerVehicleTblConfig.loading = false;
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }catch(e){
      console.error("Unexpected error in getAgencyStdRates:", e);
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }

  updateFormTable() {
    try {
      console.log("updateFormTable() called");
      let fieldPremRt = this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value;
      let fieldEffDateFrom = new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value);
      let fieldEffDateTo = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let tempInsertChecker = this.tempAddedData.find((line: { PREM_RT: any, EFF_DATE_FROM:any }) => 
        +line.PREM_RT == +fieldPremRt&&getDateNum(new Date(line.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { PREM_RT: any, EFF_DATE_FROM:any }) => 
        +line.PREM_RT == +fieldPremRt&&getDateNum(new Date(line.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );

      console.log("tempInsertChecker:", tempInsertChecker);
      console.log("tempUpdateChecker:", tempUpdateChecker);
      
      this.tableDataUpdate();
        
      // Adds Updated Data that exists in the database to an object array for updated datas
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());

        tempInsertChecker.ISS_CD= this.paramForm.get('issueCd')?.value;
        tempInsertChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempInsertChecker.PERIL_CD= this.paramForm.get('perilCd')?.value;
        tempInsertChecker.CONTRACT_TYPE_CD= this.paramForm.get('contractTypeCd')?.value;
        tempInsertChecker.CAR_COMP_GRP = this.paramForm.get('carCompGrpCd')?.value;
        tempInsertChecker.PREM_RT = +this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value;
        tempInsertChecker.ACTIVE_TAG = this.agencyStdRatesPerVehicleForm.get('activeTag')?.value;
        tempInsertChecker.COMM_RT = +this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value;
        tempInsertChecker.SERVICE_FEE_RT = this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value;
        tempInsertChecker.DEFAULT_TAG = this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value;
        tempInsertChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempInsertChecker.EFF_DATE_TO = fieldEffDateTo;
        tempInsertChecker.REMARKS = this.agencyStdRatesPerVehicleForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.agencyStdRatesPerVehicleForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.ISS_CD= this.paramForm.get('issueCd')?.value;
        tempUpdateChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempUpdateChecker.PERIL_CD= this.paramForm.get('perilCd')?.value;
        tempUpdateChecker.CONTRACT_TYPE_CD= this.paramForm.get('contractTypeCd')?.value;
        tempUpdateChecker.CAR_COMP_GRP = this.paramForm.get('carCompGrpCd')?.value;
        tempUpdateChecker.PREM_RT  = +this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.agencyStdRatesPerVehicleForm.get('activeTag')?.value;
        tempUpdateChecker.COMM_RT = +this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value;
        tempUpdateChecker.SERVICE_FEE_RT = +this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value;
        tempUpdateChecker.DEFAULT_TAG = this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value;
        tempUpdateChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempUpdateChecker.EFF_DATE_TO = fieldEffDateTo;
        tempUpdateChecker.REMARKS = this.agencyStdRatesPerVehicleForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.agencyStdRatesPerVehicleForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.agencyStdRatesPerVehicleForm.patchValue({
        activeTag: this.agencyStdRatesPerVehicleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value? new Date(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value): null;
      let updateIndex = this.agencyStdRatesPerVehicleTblConfig.tblData.indexOf(this.rowClickedData);
      console.log("Updating tableData at index:", updateIndex);
      this.agencyStdRatesPerVehicleTblConfig.tblData[updateIndex] = {
        ISS_CD: this.paramForm.get('issueCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CONTRACT_TYPE_CD: this.paramForm.get('contractTypeCd')?.value,
        CAR_COMP_GRP: this.paramForm.get('carCompGrpCd')?.value,
        PREM_RT: +this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value,
        SERVICE_FEE_RT: +this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value,
        ACTIVE_TAG: this.agencyStdRatesPerVehicleForm.get('activeTag')?.value,
        COMM_RT: +this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value,
        DEFAULT_TAG: this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value,
        EFF_DATE_FROM: new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value),
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.agencyStdRatesPerVehicleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.agencyStdRatesPerVehicleForm.get('userID')?.value,
        MODE: 'U'
      };
      this.agencyStdRatesPerVehicleTblConfig.tblData = [...this.agencyStdRatesPerVehicleTblConfig.tblData];

      console.log("tableDataUpdate() completed successfully.");
      console.log("Fetched Data after Save:", JSON.stringify(this.agencyStdRatesPerVehicleTblConfig.value, null, 2));
    }
    catch(e) {
      console.error("Error in tableDataUpdate():", e);
    }
  }

  formValueToData() {
    try {
      let fieldEffDateTo = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        ISS_CD: this.paramForm.get('issueCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CONTRACT_TYPE_CD: this.paramForm.get('contractTypeCd')?.value,
        CAR_COMP_GRP: this.paramForm.get('carCompGrpCd')?.value,
        PREM_RT: this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value,
        ACTIVE_TAG: this.agencyStdRatesPerVehicleForm.get('activeTag')?.value,
        COMM_RT: this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value,
        SERVICE_FEE_RT: this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value,
        DEFAULT_TAG: this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        ORIG_EFF_DATE_FROM: this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value,
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.agencyStdRatesPerVehicleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.agencyStdRatesPerVehicleForm.get('userID')?.value,
        MODE: 'U'
      }
      console.log("Fetched Data after Save:", JSON.stringify(this.agencyStdRatesPerVehicleForm.value, null, 2));
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.agencyStdRatesPerVehicleTblConfig.tblData = this.agencyStdRatesPerVehicleTblConfig.tblData.filter(
        function(e: any) {
          return +e.PREM_RT !== +clickData.PREM_RT||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {

          return +e.PREM_RT !== +clickData.PREM_RT||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.agencyStdRatesPerVehicleForm.patchValue({
        activeTag: this.agencyStdRatesPerVehicleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        ISS_CD: this.paramForm.get('issueCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CONTRACT_TYPE_CD: this.paramForm.get('contractTypeCd')?.value,
        CAR_COMP_GRP: this.paramForm.get('carCompGrpCd')?.value,
        PREM_RT: +this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value,
        COMM_RT: +this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value,
        SERVICE_FEE_RT: +this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        EFF_DATE_TO: fieldEffDateTo,
        ACTIVE_TAG: this.agencyStdRatesPerVehicleForm.get('activeTag')?.value,
        DEFAULT_TAG: this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value,
        REMARKS: this.agencyStdRatesPerVehicleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.agencyStdRatesPerVehicleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.agencyStdRatesPerVehicleForm.get('userID')?.value,
        MODE: 'I'
      }
      this.agencyStdRatesPerVehicleTblConfig.tblData.unshift(formToData);
      this.agencyStdRatesPerVehicleTblConfig.tblData = [...this.agencyStdRatesPerVehicleTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){

    tempChangeData.forEach(item => {
      item.SERVICE_FEE_RT = parseFloat(item.SERVICE_FEE_RT).toFixed(9);
    });

    this.apiCallService.saveAgencyStandardRatesPerVehicle(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.initOnGet();
              this.ngOnInit();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.initOnGet();
              this.ngOnInit();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        for(let item of tempChangeData){
          if(item.DEFAULT_TAG.toUpperCase()=='YES'){
            item.DEFAULT_TAG = 'Y';
          }else{
            item.DEFAULT_TAG= 'N';
          }
          item.PREM_RT = item.PREM_RT.toString();
          item.COMM_RT = item.COMM_RT.toString();
          item.SERVICE_FEE_RT = item.SERVICE_FEE_RT.toString();
        }
        this.saveData(tempChangeData);
      } else {
        this.initOnGet();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        return +e.PREM_RT==+ev.PREM_RT&&getDateNum(new Date(e.EFF_DATE_FROM))==getDateNum(new Date(ev.EFF_DATE_FROM));
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.agencyStdRatesPerVehicleForm.get('lineCode')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      let premiumRate: string = '';
      let commisionRate: string= '';
      let servicefeeRate: string = '';
      if(this.rowClickedData.PREM_RT!==''&&this.rowClickedData.PREM_RT!==null){
        premiumRate = parseFloat(this.rowClickedData.PREM_RT).toFixed(9);
      }
      if(this.rowClickedData.COMM_RT!==''&&this.rowClickedData.COMM_RT!==null){
        commisionRate = parseFloat(this.rowClickedData.COMM_RT).toFixed(9);
      }
      if(this.rowClickedData.SERVICE_FEE_RT!==''&&this.rowClickedData.SERVICE_FEE_RT!==null){
        servicefeeRate = parseFloat(this.rowClickedData.SERVICE_FEE_RT).toFixed(9);
      }
      let fieldEffDateTo = this.rowClickedData.EFF_DATE_TO?new Date(this.rowClickedData.EFF_DATE_TO):null;
      this.agencyStdRatesPerVehicleForm.patchValue({
        premiumRate: premiumRate,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        commissionRate: commisionRate,
        servicefeeRate: servicefeeRate,
        defaultTag: this.rowClickedData.DEFAULT_TAG,
        effDateFrom: new Date(this.rowClickedData.EFF_DATE_FROM),
        effDateTo: fieldEffDateTo,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.agencyStdRatesPerVehicleForm.patchValue({
        premiumRate: null,
        activeTag: 'A',
        commissionRate: null,
        servicefeeRate: null,
        defaultTag: 'No',
        effDateFrom: new Date(),
        effDateTo: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }
  
  openIssDialog() {
    try {
      this._Dialog.open(IssSrcComponent, {
        width: '512px',
        disableClose: true,
        data: {
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedIss = data.content;
          this.paramForm.get('issueCd')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_CD);
          this.paramForm.get('issueName')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_NAME);
          this.paramForm.get('issueField')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_CD + " - " + this.selectedIss.ISS_NAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openContractDialog() {
    try {
      this._Dialog.open(ContractTypeLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedContract=data.content;
          this.paramForm.get('contractTypeCd')?.setValue(Number(this.selectedContract.CONTRACT_TYPE_CD==null || this.selectedContract.CONTRACT_TYPE_CD=='' ? '' : this.selectedContract.CONTRACT_TYPE_CD));
          this.paramForm.get('contractTypeName')?.setValue(this.selectedContract.CONTRACT_TYPE_CD==null || this.selectedContract.CONTRACT_TYPE_CD=='' ? '' : this.selectedContract.CONTRACT_TYPE_DESC);
          this.paramForm.get('contractTypeField')?.setValue(this.selectedContract.CONTRACT_TYPE_CD==null || this.selectedContract.CONTRACT_TYPE_CD=='' ? '' : this.selectedContract.CONTRACT_TYPE_CD + " - " + this.selectedContract.CONTRACT_TYPE_DESC);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openPerilDialog() {
    try {
      this._Dialog.open(PerilLovComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'PERIL',
          lineCd: 'MC',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedPeril = data.content;
          this.paramForm.get('perilCd')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : padLeadingZeros(this.selectedPeril.PERIL_CD, 2));
          this.paramForm.get('perilName')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : this.selectedPeril.PERIL_LNAME);
          this.paramForm.get('perilField')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : padLeadingZeros(this.selectedPeril.PERIL_CD, 2) + " - " + this.selectedPeril.PERIL_LNAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  carCompanyGrpChecker(){
    if(this.paramForm.get("carCompGrpCd")?.value!=''&&this.paramForm.get("carCompGrpCd")?.value!=null){
      this.initOnGet();
      this.resetFormValues();
    }
  }
  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }
  populateTempData(finalData:any[], rawData:any[]){
    let lineCd = this.paramForm.get('lineCd')?.value;
    let issueCd = this.paramForm.get('issueCd')?.value;
    let perilCd = this.paramForm.get('perilCd')?.value;
    let contractTypeCd = this.paramForm.get('contractTypeCd')?.value;
    let carCompGrpCd = this.paramForm.get('carCompGrpCd')?.value;

    let filteredAddedData: any=[];
    let filteredUpdatedData: any=[];
    if(this.tempUpdateData!=null&&this.tempUpdateData.length!=0){
      filteredUpdatedData = this.tempUpdateData.filter(function(item:any){
        if(item.ISS_CD==issueCd&&item.LINE_CD==lineCd&&item.CONTRACT_TYPE_CD==contractTypeCd&&item.PERIL_CD==perilCd&&item.CAR_COMP_GRP==carCompGrpCd){
          finalData = rawData.filter(function(rawDataItem:any){
            if(rawDataItem.ISS_CD==issueCd&&rawDataItem.LINE_CD==lineCd&&rawDataItem.CONTRACT_TYPE_CD==contractTypeCd&&rawDataItem.PERIL_CD==perilCd&&rawDataItem.CAR_COMP_GRP==carCompGrpCd&&rawDataItem.PREM_RT==item.PREM_RT&&rawDataItem.EFF_DATE_FROM==item.EFF_DATE_FROM){
              return false;
            }
            else{
              return true;
            }
          })
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredUpdatedData.length!=0&&filteredUpdatedData!=null){
        finalData = finalData.concat(filteredUpdatedData);
      }
      else{
        finalData = rawData;
      }
    }
    else{
      finalData = rawData;
    }
    
    if(this.tempAddedData!=null&&this.tempAddedData.length!=0){
      filteredAddedData = this.tempAddedData.filter(function(item:any){
        if(item.ISS_CD==issueCd&&item.LINE_CD==lineCd&&item.CONTRACT_TYPE_CD==contractTypeCd&&item.PERIL_CD==perilCd){
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredAddedData.length!=0&&filteredAddedData!=null){
        finalData = finalData.concat(filteredAddedData);
      }
    }
    if(finalData.length>1){
      finalData.sort(function(a, b){
        let aPremRt = Number(a.PREM_RT);
        let bPremRt = Number(b.PREM_RT);
        return aPremRt - bPremRt;
      });

      for(let item of finalData){
        if(item.DEFAULT_TAG.toUpperCase()=='Y'){
          item.DEFAULT_TAG = 'Yes';
        }else{
          item.DEFAULT_TAG= 'No';
        }
      }
    }
    else if(finalData.length==1){
      for(let item of finalData){
        if(item.DEFAULT_TAG.toUpperCase()=='Y'){
          item.DEFAULT_TAG = 'Yes';
        }else{
          item.DEFAULT_TAG= 'No';
        }
      }
    }
    
    return finalData;
  }
  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(this.agencyStdRatesPerVehicleTblConfig.tblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(!this.defaultTagCheck(this.agencyStdRatesPerVehicleTblConfig.tblData)){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(this.rateCheck('premiumRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(this.rateCheck('servicefeeRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.paramForm.get('issueCd')?.value==='' || this.paramForm.get('issueCd')?.value===null
        ||this.paramForm.get('lineCd')?.value==='' || this.paramForm.get('lineCd')?.value===null
        ||this.paramForm.get('contractTypeCd')?.value==='' || this.paramForm.get('contractTypeCd')?.value===null
        ||this.paramForm.get('perilCd')?.value==='' || this.paramForm.get('perilCd')?.value===null
        ||this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value==='' || this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value===null 
        || this.agencyStdRatesPerVehicleForm.get('activeTag')?.value==='' || this.agencyStdRatesPerVehicleForm.get('activeTag')?.value===null 
        || this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value==='' || this.agencyStdRatesPerVehicleForm.get('commissionRate')?.value===null
        || this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value==='' || this.agencyStdRatesPerVehicleForm.get('servicefeeRate')?.value===null
        || this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value==='' || this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value===null) {
        this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  validateUpdate() {
    try {
      this.validated = false;
      let fieldPremiumRate = parseFloat(this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value);
      let fieldEffDateFrom= getDateNum(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value));
      let filteredTblData = this.agencyStdRatesPerVehicleTblConfig.tblData.filter(function(e:any){
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let ePremRT = parseFloat(e.PREM_RT);
        if(ePremRT!=fieldPremiumRate||effDateFrom!=fieldEffDateFrom){
          return true
        }
        else{
          return false
        }
      })
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(filteredTblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(!this.defaultTagCheck(filteredTblData)){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else if(this.rateCheck('servicefeeRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("agency-standard-rates-per-vehicle-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }
  duplicateCheck(tblData:any) {
    try {
      let fieldPremiumRate = parseFloat(this.agencyStdRatesPerVehicleForm.get('premiumRate')?.value);
      let fieldEffDateToValue = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value;
      let fieldEffDateFrom= getDateNum(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value))
      let fieldEffDateTo= getDateNum(new Date(fieldEffDateToValue))
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let effDateTo = getDateNum(new Date(e.EFF_DATE_TO));
        let ePremRT = parseFloat(e.PREM_RT);
        if(ePremRT!==fieldPremiumRate){
          return false
        }
        if(fieldEffDateToValue==''||fieldEffDateToValue==null){
          if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
            return true
          }
          return fieldEffDateFrom<=effDateTo;
        }
        if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
          return effDateFrom<=fieldEffDateTo;
        }
        if(fieldEffDateFrom>=effDateFrom&&fieldEffDateTo<=effDateTo){
            return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateFrom){
          return true;
        }
        if(fieldEffDateFrom<=effDateTo&&fieldEffDateTo>=effDateTo){
          return true;
        }
        return false;
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'Unable to add record. Premium rate within the entered effectivity period already exists.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  } 
  defaultTagCheck(tblData:any){
    try {
      let fieldDefaultTag = this.agencyStdRatesPerVehicleForm.get('defaultTag')?.value;
      let fieldEffDateToValue = this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value;
      let fieldEffDateFrom= getDateNum(new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value));
      let fieldEffDateTo= getDateNum(new Date(fieldEffDateToValue))
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let effDateTo = getDateNum(new Date(e.EFF_DATE_TO));
        if(fieldDefaultTag!=='Yes'||e.DEFAULT_TAG!='Yes'){
            return false;
        }
        if(effDateFrom===fieldEffDateFrom){
          return true;
        }
        if(fieldEffDateToValue==''||fieldEffDateToValue==null){
          if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
            return true
          }
          return fieldEffDateFrom<=effDateTo;
        }
        if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
          return effDateFrom<=fieldEffDateTo;
        }
        if(fieldEffDateFrom>=effDateFrom&&fieldEffDateTo<=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateFrom){
          return true;
        }
        if(fieldEffDateFrom<=effDateTo&&fieldEffDateTo>=effDateTo){
          return true;
        }
        else{
          return false;
        }
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'Unable to add record. Default rate for the effectivity period already exists. Only one record should be tagged as default under the same period of effectivity.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  effDateToCheck(){
    try{
      let pubUserStdRatesEffDateFrom= new Date(this.agencyStdRatesPerVehicleForm.get('effDateFrom')?.value).getTime();
      if(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value!==''&&this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value!==null){
        let pubUserStdRatesEffDateTo= new Date(this.agencyStdRatesPerVehicleForm.get('effDateTo')?.value).getTime();
        if(pubUserStdRatesEffDateTo<pubUserStdRatesEffDateFrom){
          this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'Unable to add record. Expiry Date must not be earlier than Effective Date', "E");
          return true
        }
        else{
          return false
        }
      }
      else{
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  rateCheck(fieldName:string){
    let rate = parseFloat(this.agencyStdRatesPerVehicleForm.get(fieldName)?.value);
    let fieldRate = this.agencyStdRatesPerVehicleForm.get(fieldName)?.value;
    let fieldLabel = '';
    if(fieldName=='premiumRate'){
      fieldLabel = 'Premium Rate'
    }
    else if(fieldName=='commissionRate'){
      fieldLabel = 'Commission Rate'
    }
    else if(fieldName=='servicefeeRate'){
      fieldLabel = 'Service Fee Rate'
    }
    if(fieldRate===''||fieldRate===null){
      return false
    }
    if(rate<0){
      this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    if(rate<1000){
      return false
    }
    else{
      this.formService.showFormMsg("agency-standard-rates-per-vehicle-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
      return true
    }
  }

  rateFormat(fieldName: string) {
    console.log("rateFormat triggered for:", fieldName);

    let fieldValue = this.agencyStdRatesPerVehicleForm.get(fieldName)?.value;
    console.log("Original Value:", fieldValue);

    if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
        let numericValue = typeof fieldValue === 'string' ? fieldValue.replace(/,/g, '') : fieldValue;
        
        let fieldFloat = parseFloat(numericValue);
        if (isNaN(fieldFloat)) {
            console.log("Invalid number, resetting field.");
            this.agencyStdRatesPerVehicleForm.get(fieldName)?.setValue('');
        } else {
            let fieldRate = fieldFloat.toFixed(9);  // Keeps 9 decimal places
            console.log("Formatted Value:", fieldRate);
            this.agencyStdRatesPerVehicleForm.get(fieldName)?.setValue(fieldRate);
        }
    }
  }

  datePattern(ev: any) {
    try{
      //let inputChar = String.fromCharCode(event.charCode)
      if (ev.target.value.length<4) {
        let firstPattern = /^\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,2);
        }
      } else if(ev.target.value.length<7){
        let firstPattern = /^\d{2}\/\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,5);
        }
      } else if(ev.target.value.length>6&&ev.target.value.length<11){
        let firstPattern = /^\d{2}\/\d{2}\/\d+$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else if(ev.target.value.length==10){
        let firstPattern = /^\d{2}\/\d{2}\/\d{4}$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else{
        ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
      }
    }
    catch(e) {
    }
  }
}
function getDateNum(dateInput:Date){
  if(dateInput==null){
    return 0;
  }
  let year = dateInput.getFullYear();
  let month = dateInput.getMonth()+1;
  let day = dateInput.getDate();
  let resultString = year+""+padLeadingZeros(month, 2)+""+padLeadingZeros(day, 2);
  
  let result = parseInt(resultString);
  return result;
}
function padLeadingZeros(num:number, size:number) {
  let sNum = num+"";
  while (sNum.length < size) sNum = "0" + sNum;
  return sNum;
}
